module.exports = __webpack_public_path__ + "img/FR12206.1fdd03dc.svg";